import { oneOf } from 'prop-types'

const ActionTypeProp = oneOf([
  'campus',
  'faculty',
  'major',
  'career',
  'test',
  'scholarship',
  'global',
])

export default ActionTypeProp
